import React from 'react';

import {ConfirmChangeEmailScreen} from 'features/auth';

const ConfirmChangeEmailPage: React.FC = () => <ConfirmChangeEmailScreen />;

export default ConfirmChangeEmailPage;
